var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoonheffingOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176.93 199.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #a6a6a6;\n      }\n\n      .cls-3 {\n        fill: #ffc727;\n      }\n\n      .cls-4, .cls-5 {\n        opacity: .1;\n      }\n\n      .cls-6 {\n        fill: #7329e8;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-7 {\n        fill: #263238;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-2--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 4.34,
    y: 2.64,
    width: 168.26,
    height: 197.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 23.47,
    y: 21.39,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 16.55,
    y: 14.76,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 30.4,
    y: 14.76,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 141.04,
    y: 14.76,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 147.96,
    y: 157.11,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 43.5,
    y: 76.82,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.43,
    y: 83.44,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0,
    y: 62.9,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0,
    y: 62.9,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0,
    y: 35,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0,
    y: 35,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.34,
    y: 40.3,
    width: 168.26,
    height: 22.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0,
    y: 0,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0,
    y: 0,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0,
    y: 194.58,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0,
    y: 194.58,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.51,
    y: 72.81,
    width: 42.02,
    height: 23.79
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.54 72.81 52.54 84.11 40.05 96.6 26.07 96.6 49.85 72.81 52.54 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.38 72.81 12.59 96.6 10.51 96.6 10.51 95.71 33.42 72.81 36.38 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.01 72.81 10.51 88.31 10.51 82.53 20.22 72.81 26.01 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.54 88.14 52.54 93.93 49.86 96.6 44.08 96.6 52.54 88.14"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.08,
    y: 70.11,
    width: 104.36,
    height: 94.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 63.66,
    y: 72.81,
    width: 99.17,
    height: 89.03
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "162.84 133.09 162.84 147.06 148.06 161.84 134.08 161.84 162.84 133.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.8 72.81 63.66 145.95 63.66 131.98 122.83 72.81 136.8 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "145.51 72.81 63.66 154.66 63.66 151.71 142.56 72.81 145.51 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "162.84 110.6 162.84 113.55 114.54 161.84 111.6 161.84 162.84 110.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "162.84 152.4 162.84 158.18 159.17 161.84 153.39 161.84 162.84 152.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.7 72.81 63.66 119.85 63.66 114.06 104.91 72.81 110.7 72.81"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 149.94,
    y: 109.33,
    width: 36.97,
    height: 0.51,
    transform: "translate(34.05 258.99) rotate(-81.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.52,127.84c0,.55.45,1,1,1s1-.45,1-1c0-.55-.45-1-1-1h0c-.55,0-1,.45-1,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 57.96,
    y: 91.07,
    width: 0.51,
    height: 36.97,
    transform: "translate(-16.21 10.3) rotate(-8.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.08,127.84c0,.55-.45,1-1,1s-1-.45-1-1c0-.55.45-1,1-1h0c.55,0,1,.45,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m52.28,90.95h121.93c-7.3-12.65-8.75-22.75-8.75-22.75H61.03s-1.43,10.1-8.75,22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m52.28,90.95v2.69c-.06,1.31.95,2.43,2.26,2.5h4.86c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.84c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5v-2.69s-121.93,0-121.93,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 34.09,
    y: 163.73,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.51,
    y: 101.63,
    width: 42.02,
    height: 98.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 16.76,
    y: 108.04,
    width: 29.52,
    height: 48.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 108.04,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 109.58,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 111.11,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 112.64,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 114.17,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 115.71,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 117.25,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 118.79,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 120.33,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 121.86,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 123.4,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 124.94,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 126.47,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 128.01,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 129.55,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 131.09,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 132.63,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 134.16,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 135.7,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 137.24,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 138.76,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 140.3,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.76,
    y: 141.84,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.29 108.04 46.29 113.85 16.76 143.38 16.76 129.39 38.13 108.04 46.29 108.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.29 138.54 46.29 152.51 42.51 156.29 28.54 156.29 46.29 138.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.29 132.41 46.29 135.36 25.36 156.29 22.41 156.29 46.29 132.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.15 108.04 16.76 126.41 16.76 120.63 29.36 108.04 35.15 108.04"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 19.4,
    y: 161.74,
    width: 22.13,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.12,
    y: 158.6,
    width: 2.59,
    height: 8.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m16.76,191.67c-.09-1.41-.14-2.83-.2-4.24-.06-1.41-.1-2.84-.14-4.25-.07-2.83-.13-5.66-.15-8.49v-.49h13.81c2.21,0,4.45.09,6.66.16,1.11,0,2.22.07,3.34.13s2.22.09,3.34.16l-3.34.16c-1.11,0-2.22.1-3.34.13-2.21.07-4.44.13-6.66.15-2.22.02-4.44.06-6.66.06h-6.66l.49-.49c0,2.83-.06,5.66-.14,8.49,0,1.41-.09,2.84-.15,4.25s-.11,2.85-.2,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m46.29,174.7c.09,1.41.14,2.83.2,4.25.06,1.42.1,2.83.15,4.24.07,2.84.11,5.66.15,8.49v.5h-13.96c-2.25,0-4.49-.09-6.73-.15l-3.38-.14c-1.11,0-2.24-.09-3.36-.16l3.36-.16c1.12,0,2.25-.1,3.38-.13,2.24-.07,4.49-.11,6.73-.15s4.49-.06,6.74-.06h6.73l-.49.49c0-2.83.07-5.65.15-8.49,0-1.41.07-2.83.15-4.24.07-1.41.1-2.88.19-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m20.59,188.47c-.15-1.76-.24-3.53-.31-5.29,0-.88-.06-1.76-.1-2.64s0-1.76,0-2.65v-.46h5.41c1.64,0,3.29,0,4.94.06,1.65.06,3.29.07,4.94.15,1.65.07,3.29.16,4.94.3-1.65.14-3.29.24-4.94.3s-3.29.13-4.94.16c-1.65.04-3.29,0-4.94,0h-4.94l.48-.48c0,.89,0,1.76-.06,2.65-.06.89,0,1.76-.09,2.64-.14,1.73-.2,3.49-.39,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m42.46,177.9c.15,1.76.25,3.53.31,5.29.06,1.76.13,3.53.16,5.29v.46h-10.48c-1.67,0-3.33-.09-5-.15-1.67-.06-3.33-.18-5-.31,1.67-.14,3.33-.24,5-.3,1.67-.06,3.33-.11,5-.15,1.66,0,3.33,0,5-.06,1.67-.06,3.33,0,5,0l-.46.46c0-1.77.05-3.53.15-5.29.07-1.76.17-3.48.31-5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.76,191.67c-.09-1.41-.14-2.83-.2-4.24-.06-1.41-.1-2.84-.14-4.25-.07-2.83-.13-5.66-.15-8.49v-.49h13.81c2.21,0,4.45.09,6.66.16,1.11,0,2.22.07,3.34.13s2.22.09,3.34.16l-3.34.16c-1.11,0-2.22.1-3.34.13-2.21.07-4.44.13-6.66.15-2.22.02-4.44.06-6.66.06h-6.66l.49-.49c0,2.83-.06,5.66-.14,8.49,0,1.41-.09,2.84-.15,4.25s-.11,2.85-.2,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m46.29,174.7c.09,1.41.14,2.83.2,4.25.06,1.42.1,2.83.15,4.24.07,2.84.11,5.66.15,8.49v.5h-13.96c-2.25,0-4.49-.09-6.73-.15l-3.38-.14c-1.11,0-2.24-.09-3.36-.16l3.36-.16c1.12,0,2.25-.1,3.38-.13,2.24-.07,4.49-.11,6.73-.15s4.49-.06,6.74-.06h6.73l-.49.49c0-2.83.07-5.65.15-8.49,0-1.41.07-2.83.15-4.24.07-1.41.1-2.88.19-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.59,188.47c-.15-1.76-.24-3.53-.31-5.29,0-.88-.06-1.76-.1-2.64s0-1.76,0-2.65v-.46h5.41c1.64,0,3.29,0,4.94.06,1.65.06,3.29.07,4.94.15,1.65.07,3.29.16,4.94.3-1.65.14-3.29.24-4.94.3s-3.29.13-4.94.16c-1.65.04-3.29,0-4.94,0h-4.94l.48-.48c0,.89,0,1.76-.06,2.65-.06.89,0,1.76-.09,2.64-.14,1.73-.2,3.49-.39,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m42.46,177.9c.15,1.76.25,3.53.31,5.29.06,1.76.13,3.53.16,5.29v.46h-10.48c-1.67,0-3.33-.09-5-.15-1.67-.06-3.33-.18-5-.31,1.67-.14,3.33-.24,5-.3,1.67-.06,3.33-.11,5-.15,1.66,0,3.33,0,5-.06,1.67-.06,3.33,0,5,0l-.46.46c0-1.77.05-3.53.15-5.29.07-1.76.17-3.48.31-5.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m52.28,90.95v2.69c-.06,1.31.95,2.43,2.26,2.5h4.86c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.84c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5-.06,1.32.95,2.44,2.27,2.5,0,0,0,0,0,0h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.84c1.32-.06,2.34-1.18,2.28-2.49,0,0,0,0,0,0-.06,1.31.95,2.43,2.26,2.5h4.85c1.31-.07,2.33-1.19,2.26-2.5v-2.69s-121.93,0-121.93,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.78,93.64c0-.9,0-1.8.1-2.69v-.06c-1.05-1.73-1.99-3.53-2.86-5.35-.88-1.82-1.64-3.69-2.36-5.57-.7-1.9-1.29-3.83-1.78-5.79l-.35-1.47c-.1-.5-.16-1-.26-1.5-.22-.99-.28-2-.44-3,.05,2.03.28,4.06.69,6.05.42,2,.98,3.96,1.67,5.88.7,1.92,1.51,3.79,2.43,5.61.45.91.94,1.8,1.46,2.69s1.04,1.75,1.62,2.57h0c.08.84.08,1.74.08,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.45,93.64c0-.9,0-1.8.1-2.69h0c-.51-.85-.99-1.73-1.44-2.61s-.85-1.8-1.25-2.71c-.78-1.83-1.44-3.7-1.99-5.61-.16-.47-.29-.95-.4-1.44-.11-.48-.26-.96-.35-1.45-.2-.97-.42-1.94-.56-2.92-.31-1.97-.52-3.95-.62-5.94-.07,2,.01,4,.26,5.99.51,3.99,1.61,7.89,3.25,11.56.81,1.84,1.79,3.59,2.92,5.25h0c0,.77.03,1.67.08,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.94,93.64c.06-2.13.06-4.24.06-6.36s0-4.24-.07-6.36c-.07-2.12-.1-4.24-.19-6.36l-.14-3.18c-.06-1.06-.11-2.13-.19-3.18,0,1.05,0,2.11-.06,3.18v3.19c0,2.11,0,4.24.07,6.36.07,2.12.11,4.24.2,6.35.09,2.11.16,4.25.31,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.53,93.64c.15-2.11.24-4.24.33-6.36.09-2.12.13-4.24.19-6.35.06-2.11.07-4.25.07-6.36v-3.19c0-1.06,0-2.13-.06-3.18-.07,1.05-.13,2.11-.19,3.18l-.14,3.18c-.09,2.13-.14,4.24-.2,6.36-.06,2.12,0,4.24-.07,6.36-.07,2.12.07,4.24.07,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m127.28,93.64c0-.9.07-1.8.11-2.69h0c-.25-1.88-.39-3.75-.55-5.66-.16-1.91-.22-3.75-.34-5.68-.11-1.93-.15-3.75-.22-5.7l-.16-5.69c-.06.94-.1,1.89-.15,2.85s0,1.9,0,2.85c0,1.9,0,3.75.09,5.7.09,1.95.22,3.81.4,5.7.09.95.2,1.9.33,2.84.13.94.26,1.89.45,2.83h0c.05.85.05,1.75.05,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m136.69,93.64c0-.9.07-1.8.11-2.69h0c-.62-1.81-1.1-3.66-1.43-5.54-.18-.95-.33-1.89-.48-2.84-.15-.95-.25-1.9-.36-2.85-.24-1.9-.35-3.81-.51-5.72l-.18-2.87c0-.96-.07-1.93-.14-2.87,0,.95-.06,1.91-.09,2.87s0,1.93,0,2.89c0,1.93.19,3.85.39,5.76.2,1.92.49,3.83.89,5.72.19.94.42,1.88.7,2.8.26.94.58,1.85.97,2.74h0c.05.8.08,1.7.11,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m146.03,93.64c0-.9,0-1.8.1-2.69v-.06c-.84-1.75-1.55-3.56-2.1-5.42-.59-1.86-1.01-3.75-1.41-5.66-.4-1.91-.65-3.84-.88-5.77-.14-.96-.16-1.94-.28-2.9-.11-.96-.1-1.95-.18-2.92v2.92s0,1.47,0,1.47c0,.49,0,.97.09,1.46l.11,1.46c0,.5.13.97.19,1.46.11.97.29,1.94.45,2.91.37,1.93.87,3.83,1.47,5.7.3.94.65,1.85,1.04,2.75.36.91.77,1.8,1.25,2.65h0c.14.84.14,1.74.14,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.67,93.64c0-.9.06-1.8.1-2.69h0c.59-.83,1.11-1.7,1.62-2.57s1.01-1.78,1.46-2.69c.91-1.81,1.71-3.66,2.41-5.56.7-1.91,1.25-3.88,1.66-5.88.42-1.99.65-4.02.69-6.05-.15,1-.21,2.01-.42,3-.1.5-.16,1-.28,1.5l-.34,1.47c-.48,1.96-1.08,3.89-1.79,5.79-.71,1.89-1.46,3.75-2.35,5.57-.89,1.82-1.81,3.62-2.86,5.35v.06c.01.89.04,1.79.09,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.03,93.64c0-.9.07-1.8.1-2.69h0c1.13-1.66,2.11-3.41,2.92-5.25.83-1.83,1.51-3.73,2.05-5.66.57-1.93.99-3.9,1.25-5.9.25-1.99.34-3.99.26-5.99-.11,1.99-.32,3.97-.63,5.94-.15.99-.37,1.95-.56,2.92-.1.49-.24.97-.35,1.45s-.25.96-.4,1.44c-.54,1.91-1.21,3.79-1.99,5.61-.4.91-.8,1.82-1.25,2.71s-.94,1.76-1.45,2.61v.06c.04.94.04,1.84.04,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.17,93.64c0-.9.07-1.8.11-2.69h0c.19-.94.31-1.87.45-2.83s.24-1.89.33-2.84c.16-1.89.33-3.75.39-5.7.06-1.95.14-3.75.1-5.7,0-.95,0-1.9-.06-2.85s-.07-1.91-.14-2.85l-.16,5.69c-.07,1.9-.13,3.75-.22,5.7-.1,1.95-.19,3.75-.35,5.68s-.29,3.75-.54,5.66h0c.04.92.05,1.82.1,2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.78,93.64c0-.9.07-1.8.11-2.69h0c.39-.89.72-1.8.97-2.74.26-.92.5-1.86.7-2.8.39-1.89.68-3.8.88-5.72.21-1.91.35-3.84.4-5.76v-2.89c0-.96,0-1.93-.09-2.87-.06.95-.1,1.91-.15,2.87l-.16,2.87c-.16,1.91-.28,3.82-.53,5.72-.1.95-.24,1.9-.36,2.85s-.29,1.89-.48,2.84c-.32,1.88-.79,3.73-1.41,5.54h0c.11.97.11,1.88.11,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.42,93.64c0-.9.07-1.8.1-2.69h0c.48-.85.89-1.74,1.25-2.65.4-.9.74-1.82,1.04-2.75.61-1.87,1.11-3.77,1.47-5.7.16-.97.35-1.94.46-2.91.06-.49.14-.96.18-1.46l.13-1.46c0-.48.02-.97.07-1.46v-1.47c0-.97,0-1.95,0-2.92-.07.97-.11,1.95-.19,2.92s-.14,1.94-.26,2.9c-.22,1.94-.5,3.88-.88,5.77s-.84,3.75-1.43,5.66c-.54,1.86-1.24,3.68-2.09,5.42v.06c.06.94.09,1.84.14,2.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164.93,187.36c.1-1.43.14-2.84.2-4.25.06-1.41.1-2.83.15-4.25.07-2.83.11-5.66.15-8.49v-.49s-.5,0-.5,0h-6.66c-2.22,0-4.44,0-6.66,0s-4.44.09-6.66.16c-1.11,0-2.22.09-3.33.13l-3.34.16c1.11.07,2.22.11,3.34.16,1.11.05,2.21.1,3.33.13,2.22.07,4.45.13,6.66.16s4.45,0,6.66,0h6.66s-.49-.49-.49-.49c0,2.83.07,5.66.15,8.49,0,1.43.07,2.84.15,4.25.07,1.41.04,2.9.19,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.4,170.38c-.09,1.41-.14,2.83-.2,4.25-.06,1.42-.1,2.83-.14,4.24-.07,2.84-.11,5.66-.15,8.5v.49s.49,0,.49,0h6.74c2.25,0,4.49,0,6.73-.06s4.49-.07,6.74-.15l3.36-.14,3.38-.15c-1.12-.07-2.25-.13-3.38-.16l-3.36-.14c-2.25-.07-4.49-.11-6.74-.15-2.25-.04-4.49-.06-6.73-.06h-6.74s.49.5.49.5c0-2.84-.06-5.66-.14-8.5,0-1.41-.09-2.83-.15-4.24-.06-1.41-.11-2.81-.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m161.1,184.15c.07-1.76.14-3.53.16-5.29v-2.64c0-.89,0-1.76,0-2.65v-.22s-.24,0-.24,0h-4.94s-4.94,0-4.94,0c-1.64,0-3.29,0-4.93.07-1.64.07-3.3.09-5,.15,1.64.06,3.29.13,5,.15,1.71.02,3.29.07,4.93.07h4.94s4.94,0,4.94,0l-.22-.22v2.65s0,2.64,0,2.64c.22,1.76.22,3.53.3,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.23,173.58c-.06,1.76-.13,3.53-.15,5.29-.02,1.76-.07,3.53-.07,5.29v.22s.22,0,.22,0h5s5,0,5,0c1.66,0,3.33,0,5-.07,1.67-.07,3.33-.07,5-.15-1.66-.06-3.33-.11-5-.14-1.67-.02-3.33-.09-5-.09h-5s-5,0-5,0l.24.22c0-1.76,0-3.53-.07-5.29-.07-1.76-.09-3.53-.16-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.19,184.15c.06-1.76.13-3.53.15-5.29v-2.64c0-.89,0-1.76,0-2.65v-.22s-.22,0-.22,0h-4.94s-4.94,0-4.94,0c-1.65,0-3.29,0-4.94.07l-4.94.15c1.65.06,3.3.13,4.94.15,1.64.02,3.29.07,4.94.07h4.94s4.94,0,4.94,0l-.22-.22v2.65s0,2.64,0,2.64c.17,1.76.24,3.53.3,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.28,173.58c0,1.76-.13,3.53-.15,5.29s-.07,3.53-.07,5.29v.22s.22,0,.22,0h5s5,0,5,0c1.66,0,3.33,0,5-.07,1.67-.07,3.33-.07,5-.15-1.66-.06-3.33-.11-5-.14-1.67-.02-3.33-.09-5-.09h-5s-5,0-5,0l.22.22c0-1.76,0-3.53-.07-5.29-.07-1.76-.05-3.53-.15-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128.01,187.36c.09-1.43.14-2.84.2-4.25s.1-2.83.14-4.25c.07-2.83.13-5.66.15-8.49v-.49s-.5,0-.5,0h-6.66c-2.21,0-4.45,0-6.66,0s-4.45.09-6.66.16c-1.11,0-2.22.09-3.34.13l-3.33.16c1.1.07,2.21.11,3.33.16,1.11.05,2.22.1,3.34.13,2.21.07,4.44.13,6.66.16s4.44,0,6.66,0h6.66s-.49-.49-.49-.49c0,2.83.07,5.66.14,8.49,0,1.43.09,2.84.15,4.25.06,1.41.13,2.9.21,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.53,170.38c-.09,1.41-.14,2.83-.2,4.25-.06,1.42-.1,2.83-.15,4.24-.07,2.84-.11,5.66-.15,8.5v.49s.5,0,.5,0h6.73c2.24,0,4.49,0,6.74-.06s4.49-.07,6.73-.15l3.38-.14c1.12,0,2.24-.09,3.36-.15-1.12-.07-2.24-.13-3.36-.16l-3.38-.14c-2.24-.07-4.49-.11-6.73-.15-2.24-.04-4.49-.06-6.74-.06h-6.73s.49.5.49.5c0-2.84-.07-5.66-.15-8.5,0-1.41-.07-2.83-.14-4.24s-.2-2.81-.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87.28,184.15c.06-1.76.13-3.53.15-5.29v-2.64c0-.89,0-1.76,0-2.65v-.22s-.15,0-.15,0h-4.94s-4.94,0-4.94,0c-1.65,0-3.29,0-5,.07-1.71.07-3.29.09-4.94.15,1.65.06,3.29.13,4.94.15,1.65.02,3.29.07,5,.07l4.88.07h4.94s-.24-.22-.24-.22v2.65s0,2.64,0,2.64c.17,1.69.22,3.45.3,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.4,173.58c-.07,1.76-.13,3.53-.16,5.29-.04,1.76-.06,3.53-.07,5.29v.22s.24,0,.24,0h5s5,0,5,0c1.66,0,3.33,0,5-.07,1.67-.07,3.33-.07,5-.15-1.66-.06-3.33-.11-5-.14-1.67-.02-3.33-.09-5-.09h-5s-5,0-5,0l.22.22c0-1.76,0-3.53-.07-5.29-.07-1.76-.09-3.53-.15-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.03,187.36c.09-1.43.14-2.84.2-4.25s.1-2.83.15-4.25c.07-2.83.11-5.66.15-8.49v-.49s-.5,0-.5,0h-6.66c-2.22,0-4.44,0-6.66,0s-4.44.09-6.66.16c-1.11,0-2.22.09-3.33.13l-3.34.16c1.11.07,2.22.11,3.34.16,1.11.05,2.21.1,3.33.13,2.22.07,4.44.13,6.66.16s4.45,0,6.66,0h6.66s-.49-.49-.49-.49c0,2.83.07,5.66.15,8.49,0,1.43.07,2.84.14,4.25s.2,2.9.2,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.56,170.38c-.09,1.41-.14,2.83-.2,4.25-.06,1.42-.1,2.83-.14,4.24-.07,2.84-.13,5.66-.15,8.5v.49s.49,0,.49,0h6.74c2.25,0,4.49,0,6.73-.06s4.49-.07,6.74-.15l3.36-.14,3.38-.15c-1.12-.07-2.25-.13-3.38-.16l-3.36-.14c-2.25-.07-4.49-.11-6.74-.15-2.25-.04-4.49-.06-6.73-.06h-6.74s.49.5.49.5c0-2.84-.06-5.66-.14-8.5,0-1.41-.09-2.83-.15-4.24s-.11-2.81-.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m18.1,53.8v2.14h-6.1v-8.4h2.75v6.25h3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m18.49,51.74c0-2.94,1.7-4.37,4.33-4.37s4.35,1.43,4.35,4.37-1.7,4.37-4.35,4.37-4.33-1.43-4.33-4.37Zm4.33,2.21c.98,0,1.6-.68,1.6-2.21s-.62-2.21-1.6-2.21-1.59.68-1.59,2.21.62,2.21,1.59,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m27.78,51.74c0-2.94,1.7-4.37,4.33-4.37s4.35,1.43,4.35,4.37-1.7,4.37-4.35,4.37-4.33-1.43-4.33-4.37Zm4.33,2.21c.98,0,1.6-.68,1.6-2.21s-.62-2.21-1.6-2.21-1.59.68-1.59,2.21.62,2.21,1.59,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m45.55,47.55v8.4h-2.88l-2.64-4.19v4.19h-2.75v-8.4h2.89l2.64,4.19v-4.19h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m54.9,47.55v8.4h-2.74v-3.13h-2.67v3.13h-2.75v-8.4h2.75v3.13h2.67v-3.13h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m58.84,49.69v1.15h3.4v1.81h-3.4v1.15h4.07v2.14h-6.82v-8.4h6.82v2.14h-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m66.71,49.69v1.19h3.14v1.9h-3.14v3.17h-2.75v-8.4h6.57v2.14h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m74.17,49.69v1.19h3.14v1.9h-3.14v3.17h-2.75v-8.4h6.57v2.14h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m81.64,55.94h-2.75v-8.4h2.75v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m91.09,47.55v8.4h-2.88l-2.64-4.19v4.19h-2.75v-8.4h2.89l2.64,4.19v-4.19h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m96.26,49.53c-.98,0-1.6.7-1.6,2.21s.62,2.21,1.6,2.21c.77,0,1.34-.47,1.49-1.31h-1.79v-1.61h4.57v4.91h-1.92l-.1-1.18c-.44.88-1.22,1.35-2.65,1.35-2.25,0-3.95-1.43-3.95-4.37s1.7-4.37,4.34-4.37c2.25,0,3.89,1.03,4.2,3.12h-2.82c-.16-.62-.71-.97-1.38-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m106.39,49.74c-.17-.31-.56-.49-1.11-.49-.65,0-1.09.19-1.09.56,0,.5,1.31.77,2.48,1.1,1.58.45,2.61,1.1,2.62,2.43.01,1.65-1.3,2.76-3.89,2.76-2.03,0-3.38-.84-3.85-2.06-.13-.29-.2-.6-.2-.91h2.76c0,.14.03.29.11.41.17.32.61.55,1.23.55s1.07-.25,1.07-.64c0-.59-1.27-.78-2.35-1.08-1.47-.4-2.64-1.15-2.64-2.35,0-1.69,1.49-2.65,3.95-2.65,1.87,0,3.16.77,3.57,1.94.1.27.16.56.15.87h-2.69c0-.17-.04-.32-.13-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m112.85,51.07l2.36-3.53h3.11l-2.95,4.2,3,4.2h-3.17l-2.36-3.53v3.53h-2.75v-8.4h2.75v3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m118.06,51.74c0-2.94,1.7-4.37,4.33-4.37s4.35,1.43,4.35,4.37-1.7,4.37-4.35,4.37-4.33-1.43-4.33-4.37Zm4.33,2.21c.98,0,1.6-.68,1.6-2.21s-.62-2.21-1.6-2.21-1.59.68-1.59,2.21.62,2.21,1.59,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m135.45,50.48c0,1.16-.5,2.09-1.39,2.59l1.72,2.87h-2.88l-1.38-2.46h-1.21v2.46h-2.75v-8.4h4.82c1.91,0,3.06,1.23,3.06,2.94Zm-3.68,1.02c.59,0,.94-.32.94-.97s-.35-.97-.94-.97h-1.46v1.93h1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m143.01,49.69h-2.21v6.25h-2.74v-6.25h-2.21v-2.14h7.16v2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m146.49,55.94h-2.75v-8.4h2.75v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m155.94,47.55v8.4h-2.88l-2.64-4.19v4.19h-2.75v-8.4h2.89l2.64,4.19v-4.19h2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m161.12,49.53c-.98,0-1.6.7-1.6,2.21s.62,2.21,1.6,2.21c.77,0,1.34-.47,1.49-1.31h-1.79v-1.61h4.57v4.91h-1.92l-.1-1.18c-.44.88-1.22,1.35-2.65,1.35-2.25,0-3.95-1.43-3.95-4.37s1.7-4.37,4.34-4.37c2.25,0,3.89,1.03,4.2,3.12h-2.82c-.16-.62-.71-.97-1.38-.97Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoonheffingOpen);
export default __webpack_public_path__ + "static/media/loonheffing-open.cb3e5ab2c674c9858e3ccd3a6dd00016.svg";
export { ForwardRef as ReactComponent };